<template>
    <div class="row">
        <!-- Número da CNH -->
        <div class="col-md-4">
            <div class="form-group">
                <label for="userNumberCNH">
                    Número da CNH
                </label>
                <input
                    :disabled="disabledFields && disabledFields.number_cnh"
                    type="text"
                    class="form-control"
                    id="userNumberCNH"
                    :value="value.number_cnh"
                    @input="updateField('number_cnh', $event.target.value)"
                />
            </div>
        </div>

        <!-- Data de Validade da CNH -->
        <div class="col-md-4">
            <div class="form-group">
                <label for="userValidityCNH">
                    Data de Validade da CNH
                </label>
                <input
                    :disabled="disabledFields && disabledFields.validity_cnh"
                    type="text"
                    class="form-control"
                    id="userValidityCNH"
                    v-mask="'##/##/####'"
                    :value="value.validity_cnh"
                    @input="updateField('validity_cnh', $event.target.value)"
                />
            </div>
        </div>

        <!-- Data da Primeira Habilitação -->
        <div class="col-md-4">
            <div class="form-group">
                <label for="userFirstCNH">
                    Data da Primeira Habilitação
                </label>
                <input
                    :disabled="disabledFields && disabledFields.pri_cnh"
                    type="text"
                    class="form-control"
                    id="userFirstCNH"
                    v-mask="'##/##/####'"
                    :value="value.pri_cnh"
                    @input="updateField('pri_cnh', $event.target.value)"
                />
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'UserDriverInfo',
    props: {
        value: {
            type: Object,
            required: true
        },
        disabledFields: {
            type: Object,
            required: false,
            default: () => {}
        }
    },
    methods: {
        updateField(field, value) {
            this.$emit('update', field, value);
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/components/User/form-components/UserDriverInfo.vue